/// <reference path="../../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Preferences pane. Pinned to Figma node 3542:5830. Two toggle rows
// — "Enter to send" and "Auto-download on cellular".

import { useState } from "react";
import { View } from "react-native";
import { Toggle } from "../controls";
import { SettingsDivider, SettingsRow } from "../SettingsRow";

export interface PreferencesPaneProps {
	readonly enterToSend?: boolean;
	readonly onEnterToSendChange?: (next: boolean) => void;
	readonly autoDownloadOnCellular?: boolean;
	readonly onAutoDownloadOnCellularChange?: (next: boolean) => void;
}

export function PreferencesPane(props: PreferencesPaneProps = {}): JSX.Element {
	// Local fallback state for the standalone (uncontrolled) SettingsView usage;
	// when the host passes controlled props they win and persist.
	const [localEnterToSend, setLocalEnterToSend] = useState(true);
	const [localAutoDownload, setLocalAutoDownload] = useState(false);

	const enterToSend = props.enterToSend ?? localEnterToSend;
	const setEnterToSend = props.onEnterToSendChange ?? setLocalEnterToSend;
	const autoDownloadOnCellular =
		props.autoDownloadOnCellular ?? localAutoDownload;
	const setAutoDownloadOnCellular =
		props.onAutoDownloadOnCellularChange ?? setLocalAutoDownload;

	return (
		<View className="flex flex-col gap-4">
			<SettingsRow
				variant="hero"
				title="Preferences"
				description="Tune the day-to-day behaviour of the app."
				testID="settings-preferences-intro"
			/>
			<SettingsRow
				title="Press Enter to send"
				description="Use Shift + Enter for a new line."
				testID="settings-preferences-enter-to-send"
			>
				<View className="flex flex-row">
					<Toggle checked={enterToSend} onChange={setEnterToSend} />
				</View>
			</SettingsRow>

			<SettingsDivider />

			<SettingsRow
				title="Auto-download on cellular"
				description="Pull attachments on metered connections instead of waiting for Wi-Fi."
				testID="settings-preferences-auto-download"
			>
				<View className="flex flex-row">
					<Toggle
						checked={autoDownloadOnCellular}
						onChange={setAutoDownloadOnCellular}
					/>
				</View>
			</SettingsRow>
		</View>
	);
}
